<p-dialog
  [closable]="!editMode()"
  modal
  [(visible)]="visible"
  [style]="{ width: '1200px', 'min-height': '60%', 'max-height': '80%' }"
  [breakpoints]="{ '1250px': '95%' }"
>
  <ng-template pTemplate="header">
    <div class="amd-header">
      <span>
        <i class="pi pi-user"></i>
      </span>
      <span class="amd-header__title">{{
        "accountManagement.dialog.title" | translate
      }}</span>
    </div>
  </ng-template>
  <div class="amd-container">
    <aside class="amd-sidebar">
      <p-menu [model]="items()" (onBlur)="$event.preventDefault()" />
    </aside>
    <main class="amd-main">
      @switch (selectedMenu()) {
        @case ("company-data") {
          <app-amd-company-data
            [visible]="visible"
            (mode)="onModeChange($event)"
          ></app-amd-company-data>
        }
        @case ("addresses") {
          <app-amd-addresses
            [visible]="visible"
            (mode)="onModeChange($event)"
          ></app-amd-addresses>
        }
        @case ("contracts") {
          <app-amd-contracts
            [visible]="visible"
            (closeDialog)="onCloseDialog()"
          ></app-amd-contracts>
        }
        @default {
          <app-amd-company-data
            [visible]="visible"
            (mode)="onModeChange($event)"
          ></app-amd-company-data>
        }
      }
    </main>
  </div>
</p-dialog>
